const styles = {
    picker: {
        width: "100% !important",
        marginTop: "2rem"
    },
    addColor: {
        width: "100%",
        padding: "0.5rem",
        marginTop: "0.2rem",
        fontSize: "1.5rem"
    },
    colorNameInput: {
        width: "100%",
        height: "70px"
    }
};
export default styles;